import { render } from "./newPartners.vue?vue&type=template&id=3987ce37"
import script from "./newPartners.vue?vue&type=script&lang=js"
export * from "./newPartners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__